import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';

const ForgotPasswordForm = ({ onModeChange }) => {
  const { t } = useTranslation();
  const { resetPassword, loading } = useAuth();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateForm = () => {
    if (!email.trim()) {
      setError(t('validation.emailRequired'));
      return false;
    } 
    
    if (!/\S+@\S+\.\S+/.test(email)) {
      setError(t('validation.emailInvalid'));
      return false;
    }
    
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      const { success } = await resetPassword(email);
      if (success) {
        setIsSubmitted(true);
      }
    }
  };

  return (
    <div className="bg-gris-clair py-8 px-4 shadow sm:rounded-lg sm:px-10">
      {isSubmitted ? (
        <div className="text-center py-4">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
            <svg className="h-6 w-6 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h3 className="mt-3 text-lg font-medium text-gris-fonce">
            {t('auth.resetPasswordSent')}
          </h3>
          <p className="mt-2 text-sm text-gris-fonce/70">
            {t('auth.checkEmail')}
          </p>
          <div className="mt-4">
            <button
              type="button"
              onClick={() => onModeChange('login')}
              className="inline-flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-bleu1 hover:bg-bleu3 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bleu1"
            >
              {t('auth.login')}
            </button>
          </div>
        </div>
      ) : (
        <>
          <h2 className="mt-2 mb-6 text-center text-xl font-bold text-gris-fonce">
            {t('auth.resetPassword')}
          </h2>
          <p className="text-sm text-gris-fonce/80 mb-6">
            {t('auth.resetPasswordInstructions')}
          </p>
          
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gris-fonce">
                {t('auth.email')}
              </label>
              <div className="mt-1">
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setError('');
                  }}
                  className={`w-full px-3 py-2 border rounded-md shadow-sm ${
                    error ? 'border-red-500' : 'border-gray-300'
                  } focus:outline-none focus:ring-2 focus:ring-bleu1`}
                />
                {error && (
                  <p className="mt-1 text-sm text-red-600">{error}</p>
                )}
              </div>
            </div>

            <div>
              <button
                type="submit"
                disabled={loading}
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-bleu1 hover:bg-bleu3 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bleu1"
              >
                {loading ? t('common.loading') : t('auth.resetPassword')}
              </button>
            </div>
          </form>

          <div className="mt-6 text-center">
            <button
              type="button"
              onClick={() => onModeChange('login')}
              className="text-sm font-medium text-bleu1 hover:text-bleu3"
            >
              {t('common.backToHome')}
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default ForgotPasswordForm;
